import {Progress} from '@/components/ui/progress'

interface ProgressBarProps {
    value: number
    label?: string
}

export function ProgressBar({value, label}: ProgressBarProps) {
    return (
        <div className="w-full space-y-1" data-testid="progress-bar">
            {label && (
                <p className="text-sm text-muted-foreground" data-testid="progress-bar-label">
                    {label}
                </p>
            )}
            <Progress value={value} />
        </div>
    )
}
